exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#productSelector .tx-item-sublabel {\n  position: absolute;\n  right: 0;\n  top: 3px;\n  line-height: 2.04081632653;\n  padding-right: 1em;\n}\n#productSelector .tx-item-label {\n  padding-right: 6em;\n}\n#productSelector > li > a {\n  position: relative;\n}\n#priceFilterButton {\n  width: 1em;\n  margin-right: 3.5em;\n}\n", ""]);

// exports
